import { Method } from '../../../constants/http';
import { DataResponse, FailureOperation } from '../../../models/common';
import { FeatureFlagStatus } from '../../../models/features';
import Settings from '../../../settings/settings';
import { resourceRequest } from '../resource-request';

export type ListFeatureFlagStatusResponse = DataResponse<FeatureFlagStatus[]>;

export const getFeatureFlagStatuses = async (
    accessToken: string,
    tenantId: string,
    flags: string[],
    activityId?: string
): Promise<ListFeatureFlagStatusResponse> => {
    const uriFlags = flags.map((flag) => encodeURIComponent(flag)).join();
    const result = await resourceRequest(
        `/featureflags?flags=${uriFlags}`,
        Method.GET,
        accessToken,
        {
            operation: FailureOperation.GetFeatureFlags,
            activityId,
        },
        `https://${tenantId}.${Settings.DiscoveryBaseHostName}`
    );

    if (result.succeeded) {
        return {
            ...result,
            data: (await result.data.json()) as FeatureFlagStatus[],
        };
    }

    return result;
};
